module.exports = __webpack_public_path__ + "img/M12螺母.SLDPRT.709e9d6d.jpg";